const DebouncedSave = {
  created() {
    this.$_saveTimers = {}
  },
  methods: {
    scheduleSave(key, fn, delay = 1000) {
      clearTimeout(this.$_saveTimers[key])
      this.$_saveTimers[key] = setTimeout(fn, delay)
    },
  },
  beforeDestroy() {
    if (this.$_saveTimers) {
      Object.values(this.$_saveTimers).forEach(clearTimeout)
    }
  },
}

export default DebouncedSave
